import { render, staticRenderFns } from "./activeOrders.vue?vue&type=template&id=73d9feac&scoped=true&"
import script from "./activeOrders.vue?vue&type=script&lang=js&"
export * from "./activeOrders.vue?vue&type=script&lang=js&"
import style0 from "./activeOrders.vue?vue&type=style&index=0&id=73d9feac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d9feac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73d9feac')) {
      api.createRecord('73d9feac', component.options)
    } else {
      api.reload('73d9feac', component.options)
    }
    module.hot.accept("./activeOrders.vue?vue&type=template&id=73d9feac&scoped=true&", function () {
      api.rerender('73d9feac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/activeOrders.vue"
export default component.exports